import { render, staticRenderFns } from "./Magasin.vue?vue&type=template&id=a36e0f98&scoped=true&"
import script from "./Magasin.vue?vue&type=script&lang=js&"
export * from "./Magasin.vue?vue&type=script&lang=js&"
import style0 from "./Magasin.vue?vue&type=style&index=0&id=a36e0f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36e0f98",
  null
  
)

export default component.exports